<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              BOQ TNKC House Inspection 2020
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — July 8, 2021
            </p>
          </div>
        </div>
        <div class="row">
<!--          <div class="col-md-12">-->
<!--            <p class="mt-2">In response to covid-19 TNKC House undergo in BOQ inspection</p>-->
<!--          </div>-->
          <div class="col-md-4 my-2" v-for="inspect in boqinspection" v-bind:key="inspect">
            <img :src="inspect" alt="" class="border">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoqTnkcHouseInspection',
  data() {
    return {
      boqinspection: [
        require(`@/assets/news/2020/tnkcinspection/boqinspect1_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect2_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect3_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect4_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect5_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect6_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect7_7-8-2021.jpg`),
        require(`@/assets/news/2020/tnkcinspection/boqinspect8_7-8-2021.jpg`)
      ],
    }
  }
};
</script>

<style scoped>

</style>
